// import { AntDesignOutlined } from "@ant-design/icons";
import { notification } from 'antd'
import axios from 'axios'

// const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  getCompanies: '/catalog/company',
  opCompany: '/catalog/company',
}

// get Companies
export async function getCompanies(token) {
  const auth = `Bearer ${token}`
  // console.log('auth:', auth)
  const url = fsConfig.root + fsConfig.getCompanies
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: auth,
    },
  }
  return axios
    .get(url, newConfig)
    .then(response => {
      const result = response.data.map((el, ndx) => {
        const o = Object.assign({}, el)
        o.key = `${ndx + 1}`
        return o
      })
      response.data = result
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error obteniendo empresas',
        description: error.message,
      })
    })
}

// add new company
export async function postCompany(token, company) {
  const url = fsConfig.root + fsConfig.opCompany
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .post(url, company, newConfig)
    .then(response => {
      /*           const result = response.data.map((el, ndx) => {
              const o = Object.assign({}, el )
              o.key = `${ndx + 1}`
              return o
          })
          response.data = result */
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error agregando empresa',
        description: error.message,
      })
    })
}

export async function putCompany(token, company) {
  const url = fsConfig.root + fsConfig.opCompany
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  const { key } = company
  delete company.key
  return axios
    .put(url, company, newConfig)
    .then(response => {
      /*           const result = response.data.map((el, ndx) => {
              const o = Object.assign({}, el )
              o.key = `${ndx + 1}`
              return o
          })
          response.data = result */
      response.key = key
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error agregando empresa',
        description: error.message,
      })
    })
}

export async function deleteCompany(token, companyUid) {
  const url = `${fsConfig.root}${fsConfig.opCompany}/${companyUid}`
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .delete(url, newConfig)
    .then(response => {
      const { result } = response.data
      return result
    })
    .catch(error => {
      notification.warning({
        message: 'Error eliminando empresa',
        description: error.message,
      })
    })
}
